export default __webpack_public_path__ + "static/media/send-back.14ac0127.svg";